import styled from "styled-components";

import { StyledDirectionIconWrapper } from "../../styles";

export const StyledDirectionIcon = styled(StyledDirectionIconWrapper)`
    & .SWReactIcons svg {
        width: 12px;
        height: 16px;
    }
`;
